import * as React from "react";
const X = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M13.06 12l6.47-6.47a.75.75 0 00-1.06-1.06L12 10.94 5.53 4.47a.75.75 0 00-1.06 1.06L10.94 12l-6.47 6.47a.757.757 0 00-.222.53c0 .198.08.393.22.532.14.14.334.22.531.22a.757.757 0 00.531-.222L12 13.06l6.47 6.47a.75.75 0 001.06-1.06z" />
  </symbol>;
export default X;